import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import { SUPPORT_PHONE, SUPPORT_PHONE_TEL } from '../constants/site';

export default function NotFound() {
  return (
    <section className="section section--dark" style={{ textAlign: 'center' }}>
      <div className="container container--narrow">
        <p className="kicker" style={{ justifyContent: 'center' }}>
          Error 404
        </p>
        <h1 className="bigcta__title">Page not found</h1>
        <p className="bigcta__text">
          The page you were looking for has moved or no longer exists. Head back to the homepage, or
          call us and we will point you in the right direction.
        </p>
        <div className="btn-row" style={{ justifyContent: 'center' }}>
          <Link to="/" className="btn btn--red btn--lg">
            Back to Home
          </Link>
          <a href={`tel:${SUPPORT_PHONE_TEL}`} className="btn btn--ghost btn--lg">
            <Icon name="phone" size={18} />
            {SUPPORT_PHONE}
          </a>
        </div>
      </div>
    </section>
  );
}
